// extracted by mini-css-extract-plugin
export default {"content":"GestaoDeLicenca_content__wBjf0"};